import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const STDEV = () => {
  return (
    <CardSection id="STDEV" title="STDEV">
      <Paragraph>
        표본 데이터 집합 내에 존재하는 평균으로부터의 변화량을 나타내는 표준
        편차를 추정합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>STDEV(VALUE_1, [VALUE_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>VALUE_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_2, ... [선택 사항]</b>은 추가 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeStdev" /> */}
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 숫자 값, 숫자 값이 포함된 열 또는 숫자 값을
          반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          데이터의 표준 편차는 분산의 제곱근입니다. 분석 중인 집합이 모든 데이터
          포인트(모집단이라고 함)를 나타내는 경우 대신 <b>STDEVP</b>를
          사용합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
